import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-workspace-categories',
    templateUrl: './workspace-categories.component.html',
    styleUrls: ['./workspace-categories.component.scss']
})
export class WorkspaceCategoriesComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}
